import { DashboardTiles } from '@common/constants';
import { TilesProps } from '@common/types';
import { useAddDashboardTile, useRemoveDashboardTile } from '@hooks/dashboard';
import { useLicencesUsageCallTimeQuery } from '@hooks/licenses';
import { pickSummary, useDualProductivityData } from '@hooks/summary';
import { DoughnutChartTile } from '@pages/InsightsAndAnalytics/tiles/DoughnutChartTile';
import { calculateTotalSeconds } from '@utils/index';

export const ServiceUsageAvgTimeSpentOnCalls: React.FC<TilesProps> = ({
  params,
  id,
  classNames,
}) => {
  const parsedParams = JSON.parse(params);
  const formatDuration = (totalSeconds: number) => {
    const safe = Math.max(0, Math.round(totalSeconds));
    const hours = Math.floor(safe / 3600)
      .toString()
      .padStart(2, '0');
    const minutes = Math.floor((safe % 3600) / 60)
      .toString()
      .padStart(2, '0');
    const seconds = Math.floor(safe % 60)
      .toString()
      .padStart(2, '0');
    return `${hours}:${minutes}:${seconds}`;
  };

  const { data: licencesCallTimeData, isLoading: isLicencesCallTimeLoading } =
    useDualProductivityData({
      legacyParams: parsedParams,
      useLegacyQuery: useLicencesUsageCallTimeQuery,
      mapSummary: (grouped) => {
        const summary = pickSummary(grouped, 'UserActivity');
        const phoneSecondsRaw = Number(summary?.aggregates?.TotalPhoneCallsDuration ?? 0);
        const videoSecondsRaw = Number(summary?.aggregates?.TotalVideoCallsDuration ?? 0);
        const phoneSeconds = Number.isFinite(phoneSecondsRaw) ? phoneSecondsRaw : 0;
        const videoSeconds = Number.isFinite(videoSecondsRaw) ? videoSecondsRaw : 0;

        return {
          phoneCalls: formatDuration(phoneSeconds),
          videoCalls: formatDuration(videoSeconds),
        };
      },
    });
  const { removeMenuItem } = useRemoveDashboardTile(id);
  const { addMenuItem } = useAddDashboardTile(
    DashboardTiles.ServiceUsageAvgTimeSpentOnCalls,
    ''
  );
  const isOnDashboardPage = !!id;

  return (
    <DoughnutChartTile
      dropdownMenuItemClasses={'!w-[300px]'}
      classNames={'col-span-6 md:col-span-3 xl:col-span-2'}
      contextData={isOnDashboardPage ? removeMenuItem : addMenuItem}
      headerTitle={'Service usage: Avg time spent on calls / person'}
      isLoading={isLicencesCallTimeLoading}
      data={
        licencesCallTimeData
          ? [
              calculateTotalSeconds(licencesCallTimeData.phoneCalls),
              calculateTotalSeconds(licencesCallTimeData.videoCalls),
            ]
          : []
      }
      dataLabels={['Phone calls', 'Video calls']}
      dataLabelValues={
        licencesCallTimeData
          ? [licencesCallTimeData.phoneCalls, licencesCallTimeData.videoCalls]
          : []
      }
    />
  );
};
